import './CardSection.css'
import React, { Component } from 'react'
import { CardElement, injectStripe } from 'react-stripe-elements'
import { StripeAsyncProvider } from '../stripe'
import { Input } from 'components/base'

class CardSection extends Component {
  render() {
    return (
      <form id="card-section" onSubmit={this.onFormSubmit}>
        <div style={{ gridArea: 'cardholder' }}>
          <label
            htmlFor="cardholder-name"
            className="font-weight-bold font-size-large shade-05"
          >
            Cardholder name
          </label>
          <Input
            id="cardholder-name"
            value={this.props.cardholderName}
            onChange={this.onCardholderNameChange}
          />
        </div>
        <div style={{ gridArea: 'card' }}>
          <label
            htmlFor="card"
            className="font-weight-bold font-size-large shade-05"
          >
            Credit or debit card
          </label>
          <CardElement
            id="card"
            classes={{
              base:
                'no-box-shadow border-small radius-normal margin-vertical-small padding-horizontal-medium padding-vertical-normal font-size-small',
              normal: 'border-shade-40',
              empty: 'border-shade-40',
              focus: 'border-shade-30',
              invalid: 'border-red',
              complete: 'border-green',
            }}
            onChange={this.onCardChange}
          />
        </div>
      </form>
    )
  }

  onCardholderNameChange = event => {
    this.props.onCardholderNameChange(event.target.value)
  }

  onCardChange = card => {
    this.props.onCardChange(this.props.stripe, card)
  }
}

const InjectedCardSection = injectStripe(CardSection)

export default class StripeWrappedCardSection extends Component {
  render() {
    return (
      <StripeAsyncProvider apiKey="pk_test_1TMpdQ5KcxT6WpxgeN5bMmoi">
        <InjectedCardSection
          onStripeFormSubmit={this.props.onStripeFormSubmit}
          cardholderName={this.props.cardholderName}
          onCardholderNameChange={this.props.onCardholderNameChange}
          onCardChange={this.props.onCardChange}
        />
      </StripeAsyncProvider>
    )
  }
}
